/**
 * Clients API — Endpoint 7
 *
 * API 7 : GET /api/clients/{clientId}/features
 *         → Full feature timeline for a specific client
 */
import { apiFetch, buildUrl } from "./apiClient";

/**
 * API 7 — Get the feature timeline for a specific client.
 * Returns all features released to that client, sorted by releaseDate.
 *
 * @param {string} clientId - e.g. "ORG1"
 * @param {number} [limit=50]
 * @param {string} [cursor]
 * @returns {Promise<{ data: { clientId, featureId, releaseId, releaseDate, status }[], meta: object }>}
 */
export async function fetchClientFeatures(clientId, limit = 50, cursor) {
    if (!clientId) throw new Error("clientId is required.");
    const path = buildUrl(
        `/api/clients/${encodeURIComponent(clientId)}/features`,
        { limit, cursor }
    );
    return apiFetch(path);
}
